import {
    FETCH_PLAYER_ACTIVE_SALES_POINTS_BEGIN,
    FETCH_PLAYER_ACTIVE_SALES_POINTS_ERROR,
    FETCH_PLAYER_ACTIVE_SALES_POINTS_SUCCESS
} from "../actions/player/playerActiveSalesPointsActions";
import {
    FETCH_PLAYER_MEDIA_STATS_BEGIN,
    FETCH_PLAYER_MEDIA_STATS_ERROR,
    FETCH_PLAYER_MEDIA_STATS_SUCCESS
} from "../actions/player/playerMediaStatsActions";
import {
    FETCH_PLAYER_SALES_POINT_STATS_BEGIN,
    FETCH_PLAYER_SALES_POINT_STATS_ERROR,
    FETCH_PLAYER_SALES_POINT_STATS_SUCCESS
} from "../actions/player/playerSalesPointStatsActions";

const defaultPlayerSalesPointStats = {
    playerSalesPointStats: [],
    pagination: {},
    loading: false,
    error: null
}

const defaultPlayerActiveSalesPoints = {
    playerActiveSalesPoints: [],
    pagination: {},
    loading: false,
    error: null
};

const defaultPlayerMediaStats = {
    playerMediaStats: [],
    pagination: {},
    loading: false,
    error: null
}

export const playerSalesPointStats = (state = defaultPlayerSalesPointStats, action) => {
    switch (action.type) {
        case FETCH_PLAYER_SALES_POINT_STATS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_PLAYER_SALES_POINT_STATS_SUCCESS:
            return {
                ...state,
                loading: false,
                playerSalesPointStats: action.payload.playerSalesPointStats,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PLAYER_SALES_POINT_STATS_ERROR:
            return {
                ...state,
                loading: false,
                playerSalesPointStats: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};

export const playerActiveSalesPoints = (state = defaultPlayerActiveSalesPoints, action) => {
    switch (action.type) {
        case FETCH_PLAYER_ACTIVE_SALES_POINTS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_PLAYER_ACTIVE_SALES_POINTS_SUCCESS:
            return {
                ...state,
                loading: false,
                playerActiveSalesPoints: action.payload.playerActiveSalesPoints,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PLAYER_ACTIVE_SALES_POINTS_ERROR:
            return {
                ...state,
                loading: false,
                playerActiveSalesPoints: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};

export const playerMediaStats = (state = defaultPlayerMediaStats, action) => {
    switch (action.type) {
        case FETCH_PLAYER_MEDIA_STATS_BEGIN:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_PLAYER_MEDIA_STATS_SUCCESS:
            return {
                ...state,
                loading: false,
                playerMediaStats: action.payload.playerMediaStats,
                pagination: {
                    numberOfElements: action.payload.numberOfElements,
                    totalElements: action.payload.totalElements,
                    totalPages: action.payload.totalPages
                },
            };
        case FETCH_PLAYER_MEDIA_STATS_ERROR:
            return {
                ...state,
                loading: false,
                playerMediaStats: [],
                error: action.payload.error
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/playerStats.js